import * as JSONMapper from "json-mapper";
import {jsonProperty} from "json-mapper-reflect";
import {AvdbRegion} from "../avdb-region";
import {AvdbPricingProductRegionGeoCoverage} from "./avdb-pricing-product-region-geo-coverage";

export class AvdbPricingProductRegion extends AvdbRegion {
	@jsonProperty(JSONMapper.classByMethods(AvdbPricingProductRegionGeoCoverage))
	geoCoverage: AvdbPricingProductRegionGeoCoverage;

	@jsonProperty()
	fixedWingEligible: boolean;

	@jsonProperty()
	helicopterEligible: boolean;

	constructor(data?: Partial<AvdbPricingProductRegion>) {
		super();
		Object.assign(this, data);
	}

	get displayName(): string {
		return (this.vendorName) ? `${this.name} by ${this.vendorName}` : this.name;
	}
}
